import { computed } from 'vue';
import { useI18n } from '@/plugins/i18n';
import { devLog } from '@/common/debug';

export interface SelectedOptions {
  category?: string;
  section?: string;
  article?: string;
}

export function useTicketSubject(
  matchSource: 'CATEGORY' | 'ARTICLE' | 'SECTION' | null,
  selectedOptions: SelectedOptions
) {
  const { t } = useI18n();

  const ticketSubject = computed(() => {
    const matchSourceMap = {
      CATEGORY: selectedOptions.category,
      SECTION: selectedOptions.section,
      ARTICLE: selectedOptions.article,
    };

    if (!matchSource || !matchSourceMap[matchSource]) {
      devLog.log('[OPEN_REQUEST_MODAL] No match source found for', matchSource);
      return 'Request';
    }

    const textStart = `${t('chat.chat_trigger.open_request.request')}:`;

    if (matchSource === 'SECTION') {
      const category = selectedOptions.category;
      const section = matchSourceMap[matchSource];

      if (category) {
        return `${textStart} ${category} > ${section}`;
      } else {
        return `${textStart} ${section}`;
      }
    }

    if (matchSource === 'ARTICLE') {
      const category = selectedOptions.category;
      const article = matchSourceMap[matchSource];

      if (category) {
        return `${textStart} ${article} > ${category}`;
      } else {
        return `${textStart} ${article}`;
      }
    }

    return `${textStart} ${matchSourceMap[matchSource]}`;
  });

  return {
    ticketSubject,
  };
}
